import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { configPropertyUpdateFailure, configPropertyUpdateSuccess } from '../../actions/configPropertyActions/configPropertyUpdateActions';
import store from '../../configStore';

function* configPropertyUpdate({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.updateConfigPropertiesById,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("UPDATE_CONFIG_PROPERTY_SUCCESS status :", response.data.status);
        console.log("UPDATE_CONFIG_PROPERTY_SUCCESS data :", response.data.response);
        console.log("UPDATE_CONFIG_PROPERTY_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            configPropertyUpdateSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("UPDATE_CONFIG_PROPERTY_FAILURE status :", error?.response?.status);
        console.log("UPDATE_CONFIG_PROPERTY_FAILURE data:", error?.response?.data);
        console.log("UPDATE_CONFIG_PROPERTY_FAILURE error :", error);
        console.log('====================================');
        yield put(configPropertyUpdateFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* configPropertyUpdateSaga() {
    yield takeLatest(actionTypes.UPDATE_CONFIG_PROPERTY_REQUEST, configPropertyUpdate);
}

export default configPropertyUpdateSaga;
